<script>
    export default {
        props: {
            tag: {
                type: String,
                default: 'div'
            }
        },
        render (createElement) {
            return createElement(this.tag, {
                class: 'grid-layout'
            }, this.$slots.default)
        }
    }
</script>
